import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOrgList, resetOrgDropdownList } from '../../actions/org';
import { actualValueForDropdown, debounce, OrgTypes } from '../../utils/common';
import Select from '../../common/Form/Select';
import { useFormContext } from 'react-hook-form';
import { CLEAR_ORG_LIST_DROPDOWN_LIST_DATA, CLEAR_VENDOR_ORG_LIST_DROPDOWN_LIST_DATA } from '../../types/org';

export default function Vendors({ name, label, onChange = () => { }, prefill, required, disabled, className = 'w-full', prefillObj = {}, vendors_from, get_verification_data = false }) {
    const dispatch = useDispatch();
    const methods = useFormContext();
    const vendorOrgListDropdown = useSelector((state) => state.org.vendorOrgListDropdown);
    const isOrgListLoading = useSelector((state) => state.loading.isOrgListLoading);


    const getOrganisationList = ({ limit = 100, page = 1, query = '', vendors_from, get_verification_data }) => {
        dispatch(getOrgList({ limit, page, query, dropdown: true, type: OrgTypes.VENDOR, vendors_from, get_verification_data }));
    };

    const debouncedOrgSearchSearch = useCallback(debounce(getOrganisationList), []);

    useEffect(() => {
        getOrganisationList({ limit: 100, page: 1, query: '', vendors_from, get_verification_data });
        return () => {
            dispatch(resetOrgDropdownList());
        }
    }, [vendors_from, get_verification_data]);

    useEffect(() => {
        if (prefillObj && Object.keys(prefillObj).length > 0) {
            methods.setValue(name, prefillObj);
        } else if (prefill && vendorOrgListDropdown && vendorOrgListDropdown.length > 0) {
            const find = vendorOrgListDropdown.find((option) => option.id === prefill);
            if (find) {
                methods.setValue(name, find);
            }
        }
    }, [prefill, vendorOrgListDropdown, prefillObj]);


    useEffect(() => {
        return () => {
            dispatch({ type: CLEAR_VENDOR_ORG_LIST_DROPDOWN_LIST_DATA });
        }
    }, [dispatch]);

    return (
        <Select
            className={className}
            label={label}
            name={name}
            required={required}
            options={vendorOrgListDropdown}
            isLoading={isOrgListLoading}
            onInputChange={(event) => {
                if (event.length > 0) {
                    debouncedOrgSearchSearch({ query: event, vendors_from, get_verification_data })
                }
            }}
            onChange={(event) => {
                const orgId = actualValueForDropdown(event);
                if (orgId) {
                    onChange(orgId, event)
                }
            }}
            readOnly={disabled}
        />
    )
}
